import {
  ExternalLink,
} from 'lucide-react'

import {
  useEffect,
  useState,
} from 'react'

import {
  CustomizationPanel,
} from '../platform/layout/CustomizationPanel'

import {
  ContextualMenu,
} from '../platform/contextual/ContextualMenu'

import {
  ContextualSurface,
} from '../platform/contextual/ContextualSurface'

import {
  useLayout,
} from '../platform/preferences/LayoutContext'

interface Props {
  onOpenLAIA: () => void
}

function ClockOptions() {
  const {
    preferences,
    update,
  } =
    useLayout()

  return (
    <div className="r7-special-options">

      <label className="r7-range">
        <span>
          Tamaño hora

          <strong>
            {Math.round(
              preferences
                .clockTimeScale *
                100,
            )}%
          </strong>
        </span>

        <input
          type="range"
          min=".70"
          max="1.60"
          step=".02"
          value={
            preferences
              .clockTimeScale
          }
          onChange={
            event =>
              update({
                clockTimeScale:
                  Number(
                    event.target.value,
                  ),
              })
          }
        />
      </label>

      <label className="r7-inline-control">
        <span>
          Color hora
        </span>

        <input
          type="color"
          value={
            preferences
              .clockTimeColor
          }
          onChange={
            event =>
              update({
                clockTimeColor:
                  event.target.value,
              })
          }
        />
      </label>

      <label className="r7-range">
        <span>
          Tamaño fecha

          <strong>
            {Math.round(
              preferences
                .clockDateScale *
                100,
            )}%
          </strong>
        </span>

        <input
          type="range"
          min=".70"
          max="1.60"
          step=".02"
          value={
            preferences
              .clockDateScale
          }
          onChange={
            event =>
              update({
                clockDateScale:
                  Number(
                    event.target.value,
                  ),
              })
          }
        />
      </label>

      <label className="r7-inline-control">
        <span>
          Color fecha
        </span>

        <input
          type="color"
          value={
            preferences
              .clockDateColor
          }
          onChange={
            event =>
              update({
                clockDateColor:
                  event.target.value,
              })
          }
        />
      </label>

      <label className="r7-toggle">
        <input
          type="checkbox"
          checked={
            preferences
              .clock24Hour
          }
          onChange={
            event =>
              update({
                clock24Hour:
                  event.target.checked,
              })
          }
        />

        Formato 24 horas
      </label>

      <label className="r7-toggle">
        <input
          type="checkbox"
          checked={
            preferences
              .showDate
          }
          onChange={
            event =>
              update({
                showDate:
                  event.target.checked,
              })
          }
        />

        Mostrar fecha
      </label>

    </div>
  )
}

export function TopBar({
  onOpenLAIA,
}: Props) {
  const [
    now,
    setNow,
  ] =
    useState(
      new Date(),
    )

  const {
    preferences,
  } =
    useLayout()

  useEffect(() => {
    const timer =
      window.setInterval(
        () =>
          setNow(
            new Date(),
          ),
        1000,
      )

    return () =>
      window.clearInterval(
        timer,
      )
  }, [])

  return (
    <header className="topbar">

      <div className="brand">

        <div className="brand-icon">
          ⌘
        </div>

        <div>
          <strong>
            SEI OS
          </strong>

          <small>
            Sistema Operativo Inteligente
            · SEI ÁguiLeón
          </small>
        </div>

      </div>

      <div className="environment">

        <span className="badge production">
          PRODUCCIÓN
        </span>

        <span className="badge supervised">
          SUPERVISED_FULL
        </span>

        <span className="badge">
          Genesis vNext
        </span>

      </div>

      <div className="top-actions">

        <ContextualSurface
          id="surface:top-buttons"
          title="Botones superiores"
          allowHide={false}
          className="r7-top-controls"
        >
          <div className="r7-top-button-row">

            <button
              type="button"
              className="secondary-button"
              onClick={
                onOpenLAIA
              }
            >
              <ExternalLink
                size={16}
              />

              LAIA
            </button>

            <CustomizationPanel />

          </div>
        </ContextualSurface>

        <div className="r7-clock-wrapper">

          <div className="clock">

            <strong className="clock-time">
              {now.toLocaleTimeString(
                'es-MX',
                {
                  hour12:
                    !preferences
                      .clock24Hour,
                },
              )}
            </strong>

            {
              preferences.showDate
              && (
                <span className="clock-date">
                  {now.toLocaleDateString(
                    'es-MX',
                    {
                      weekday:
                        'long',

                      day:
                        '2-digit',

                      month:
                        'long',

                      year:
                        'numeric',
                    },
                  )}
                </span>
              )
            }

          </div>

          <ContextualMenu
            id="surface:clock"
            title="Reloj y fecha"
            allowHide={false}
            showBaseControls={false}
          >
            <ClockOptions />
          </ContextualMenu>

        </div>

      </div>

    </header>
  )
}
